<template>
  <div
    class="_flex align-center"
    v-if="showNotification"
  >
    <p class="lips _m0">This member is either termed or voided, continue?</p>
    <button
      :disabled="executing"
      class="_mlxs btn --sm"
      @click="showNotification = false"
    >
      No
    </button>
    <async-button
      type='button'
      :executing="executing"
      class="_mlxs btn --sm white"
      @clicked="sendMailIdCardRequest"
    >
      Yes
    </async-button>
  </div>
  <async-button
    v-else-if="memberDetails.member.requestIdCard && memberDetails.member.memberType === 'Subscriber'"
    type='button'
    class="_mls _mt0 white --sm"
    :executing="executing"
    @clicked='mailCard'
    :disabled='success'
  >
    <template #buttonContent>
      <span v-if="success">
        ID Card Mailed
        <font-awesome-icon icon="check-circle" class="_mlxs" aria-label="check"/>
      </span>
      <span v-else >
        Mail ID Card
      </span>
    </template>
  </async-button>

</template>

<script>
  import AsyncButton from '@molecules/AsyncButton'
  import MemberEditApi from '@api/MemberEditApi'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import memberManagement from '@mixins/memberManagement'
  import moment from 'moment'

  export default {
    components: {
      AsyncButton,
      FontAwesomeIcon
    },
    mixins: [memberManagement],
    data () {
      return {
        executing: false,
        success: false,
        showNotification: false
      }
    },
    computed: {
      memberTermedOrVoided () {
        return (
          moment(this.memberDetails.member.termDate) < moment() ||
          this.memberDetails.member.memberVoided
        )
      }
    },
    methods: {
      mailCard () {
        if (this.memberTermedOrVoided) {
          this.showNotification = true
        } else {
          this.sendMailIdCardRequest()
        }
      },
      sendMailIdCardRequest () {
        this.executing = true
        new MemberEditApi({
          simulateExample: 'Success - Request ID Cards'
        })
          .mailMemberIdCards({
            body: {
              subscriberCk: this.memberDetails.member.subscriberCk,
              memberCk: this.memberDetails.member.memberCk,
              groupCk: this.memberDetails.member.groupCk,
              subGroupCk: this.memberDetails.member.subgroupCk || this.memberDetails.member.subGroupCk,
              classId: this.memberDetails.member.classId,
              classPlanId: this.memberDetails.member.planId
            }
          })
          .then(response => {
            this.executing = false
            this.success = true
            this.showNotification = false
          })
          .catch(_ => {
            this.executing = false
          // todo, what happens when we error?
          })
      }
    },
    watch: {
      'showNotification' (notificationShowing, notificationWasShowing) {
        this.$emit('notificationToggled', notificationShowing)
      }
    }
  }
</script>
